import ShowBadges from '../components/settings/ShowBadges'
import ManageGroups from '../components/settings/ManageGroups'
import SupportLink from '../components/settings/SupportLink'

const Settings = () => (
  <div className="relative">
    <h1 className="text-base font-bold pb-4 hidden sm:block">Settings</h1>
    <ShowBadges />
    <ManageGroups />
    <div className="fixed bottom-0 pb-4 bg-white w-full">
      <SupportLink />
    </div>
  </div>
)

export default Settings
